export const SETTINGS = {
  TOAST_LIFE: 5000,
  PASSWORD_MIN_LENGTH: 8,
  AUTOCOMPLETE_COUNTRY_RESTRICTION: 'nl',
  MAX_ALTERNATIVE_LESSON: 2,
};
